import {
  GET_LIST_CAMDO,
  GET_LIST_CAMDO_SUCCESS,
  GET_LIST_CAMDO_FAILURE,
  GET_SOTAISANTHANHLY_CAMDO,
  GET_SOTAISANTHANHLY_CAMDO_SUCCESS,
  GET_SOTAISANTHANHLY_CAMDO_FAILURE,
} from "actions/CamDo/actionTypes";

const initialState = {
  getListCamDoLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
  SoTaiSanThanhLy: 0,
  dataSearch: {},
  isShowFormCamDo: false,
  choVayEditID: 0,
};

const getListCamDo = (state, action) => ({
  ...state,
  getListCamDoLoading: true,
  dataSearch: action.dataSearch,
});

const getListCamDoSuccess = (state, action) => {
  return {
    ...state,
    getListCamDoLoading: false,
    objList: action.payload,
  };
};

const getListCamDoFailed = (state, action) => ({
  ...state,
  getListCamDoLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const getSoTaiSanThanhLyCamDo = (state, action) => ({
  ...state,
});

const getSoTaiSanThanhLyCamDoSuccess = (state, action) => {
  return {
    ...state,
    SoTaiSanThanhLy: action.payload,
  };
};

const getSoTaiSanThanhLyCamDoFailed = (state, action) => ({
  ...state,
  SoTaiSanThanhLy: 0,
});

const camdoReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_CAMDO:
      return getListCamDo(state, action);
    case GET_LIST_CAMDO_SUCCESS:
      return getListCamDoSuccess(state, action);
    case GET_LIST_CAMDO_FAILURE:
      return getListCamDoFailed(state, action);
    case GET_SOTAISANTHANHLY_CAMDO:
      return getSoTaiSanThanhLyCamDo(state, action);
    case GET_SOTAISANTHANHLY_CAMDO_SUCCESS:
      return getSoTaiSanThanhLyCamDoSuccess(state, action);
    case GET_SOTAISANTHANHLY_CAMDO_FAILURE:
      return getSoTaiSanThanhLyCamDoFailed(state, action);

    default:
      return state;
  }
};

export default camdoReducer;
